import { render, staticRenderFns } from "./AcordeaoCategoriaProduto.vue?vue&type=template&id=592130d4&scoped=true"
import script from "./AcordeaoCategoriaProduto.vue?vue&type=script&lang=js"
export * from "./AcordeaoCategoriaProduto.vue?vue&type=script&lang=js"
import style0 from "./AcordeaoCategoriaProduto.vue?vue&type=style&index=0&id=592130d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592130d4",
  null
  
)

export default component.exports